module.exports = __webpack_public_path__ + "static/vol5_01-96bc4e4961798116220abc8afcd5a9f6.gif";